import { createSlice } from '@reduxjs/toolkit';
import { t_cpap_instructions } from 'types';
import { getListMedicalFromCPAP, getCpapInstructItems, getCsvListMedicalFromCPAP } from './thunk';

interface InitialState {
  loading: boolean;
  search_loading: boolean;
  items: t_cpap_instructions[];
  totalItems: number;
  itemSearch: t_cpap_instructions[];
  check: boolean;
  searchValue: {
    period_of_no_visit_medical: any;
    facility_name: string;
    patient_name: string;
  };
}

const initialState: InitialState = {
  loading: false,
  search_loading: false,
  items: [],
  totalItems: 0,
  itemSearch: [],
  check: true,
  searchValue: { period_of_no_visit_medical: '', facility_name: '', patient_name: '' },
};

const consultationHistorySlice = createSlice({
  name: 'cpapInstructions',
  initialState,
  reducers: {
    isActive(state, action) {
      state.check = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCpapInstructItems.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getCpapInstructItems.fulfilled, (state, action) => {
      return { ...state, ...action.payload, loading: false };
    });
    builder.addCase(getCpapInstructItems.rejected, (state) => {
      return { ...state, loading: false };
    });
    builder.addCase(getListMedicalFromCPAP.pending, (state) => {
      return { ...state, search_loading: true };
    });
    builder.addCase(getListMedicalFromCPAP.fulfilled, (state, action) => {
      return { ...state, itemSearch: action.payload.items, ...action.payload, search_loading: false };
    });
    builder.addCase(getListMedicalFromCPAP.rejected, (state) => {
      return { ...state, search_loading: false };
    });
  },
});
export const { isActive } = consultationHistorySlice.actions;
export default consultationHistorySlice.reducer;
